module.exports = __webpack_public_path__ + "3506201220bbfefb52296b87a16cb491.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00000924.png
// module id = 1538
// module chunks = 0